export default __webpack_public_path__ + "static/media/about-hero-600.b1a7599a.svg";